import React from 'react';
import { ChartSign, DataSourceState } from '../../../../../../types';
import { useChartStoreFieldActions } from '../../../../../../context';
import { findFieldByCommonId, IntersectedField } from '../../utils';
import FieldRowBase from '../../../fieldRowBase';

type Props = {
    field: IntersectedField;
    schemaSources: DataSourceState[];
};

const ConsolidatedFieldRow = React.memo(function ConsolidatedFieldRow({ field, schemaSources }: Props) {
    const { changeFieldChartSign, toggleFieldChartType, toggleFieldAnnotation, toggleFieldSeparateAxis } = useChartStoreFieldActions();

    const representativeSource = schemaSources.find((s) => s.id === field.sourceId);
    const fieldConfig = representativeSource?.fieldsCfg[field.fieldId];
    if (!fieldConfig) {
        return null;
    }

    const { chartSign, seriesType, annotationsEnabled, separateAxis, label } = fieldConfig;

    const applyToAllSources = (action: (sourceId: number, fieldId: string) => void) => {
        for (const source of schemaSources) {
            const fId = findFieldByCommonId(source, field.commonFieldId);
            if (fId) {
                action(source.id, fId);
            }
        }
    };

    return (
        <FieldRowBase
            label={label}
            chartSign={chartSign}
            seriesType={seriesType}
            annotationsEnabled={annotationsEnabled}
            separateAxis={separateAxis}
            onToggleSelection={() =>
                applyToAllSources((sId, fId) =>
                    changeFieldChartSign(sId, fId, chartSign !== ChartSign.OFF ? ChartSign.OFF : ChartSign.POSITIVE)
                )
            }
            onToggleSign={() =>
                applyToAllSources((sId, fId) =>
                    changeFieldChartSign(sId, fId, chartSign === ChartSign.POSITIVE ? ChartSign.NEGATIVE : ChartSign.POSITIVE)
                )
            }
            onToggleChartType={() => applyToAllSources((sId, fId) => toggleFieldChartType(sId, fId))}
            onToggleAnnotation={() => applyToAllSources((sId, fId) => toggleFieldAnnotation(sId, fId))}
            onToggleSeparateAxis={() => applyToAllSources((sId, fId) => toggleFieldSeparateAxis(sId, fId))}
        />
    );
});

export default ConsolidatedFieldRow;
